import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { union, path, identity, any, propEq, sortBy, prop } from "ramda";

// Actions
export const ADD_BOOKMARK = "USER@BOOKMARK::ADD";
export const ADD_BOOKMARK_MULTIPLE = "USER@BOOKMARK::ADD_MULTIPLE";
export const REMOVE_BOOKMARK = "USER@BOOKMARK::REMOVE";
export const UPDATE_BOOKMARK = "USER@BOOKMARK::UPDATE";

// Action Creators
export const addBookmark = createAction(ADD_BOOKMARK);
export const addAllBookmarks = createAction(ADD_BOOKMARK_MULTIPLE);
export const removeBookmark = createAction(REMOVE_BOOKMARK);
export const updateBookmark = createAction(UPDATE_BOOKMARK);

// Selectors
const getBookmarks = path(["user", "bookmarks"]);

export const selectBookmarks = createSelector(getBookmarks, identity);

export const selectBookmarksSorted = createSelector(
  selectBookmarks,
  sortBy(prop("page"))
);

export const selectHasBookmarkOnPage = pageNumber =>
  createSelector(selectBookmarks, any(propEq("page", pageNumber)));

// Initial State
const initialState = () => [];

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case ADD_BOOKMARK:
      return [
        ...state,
        {
          _id: `bookmark_page_${action.payload.page}`,
          type: "bookmark",
          ...action.payload
        }
      ];
    case ADD_BOOKMARK_MULTIPLE:
      return union(state, action.payload);
    case REMOVE_BOOKMARK:
      return state.filter(bookmark => bookmark.page !== action.payload);
    case UPDATE_BOOKMARK:
      return state.map(bookmark =>
        bookmark._id === action.payload._id
          ? { ...bookmark, ...action.payload }
          : bookmark
      );
    default:
      return state;
  }
}
